import gsap from 'gsap'

export function duffyAnimation () {
  //return; 
  let timeline1 = new gsap.timeline({ 
    repeat: 0, 
    paused: false
  });

  let targetWidth = (window.innerWidth > 1000) 
    ? "550px"
    : "300px";

  let targetPhoto = (window.innerWidth > 576) 
    ? "#duffyphoto1"
    : "#duffyphoto2";

  timeline1
    .set("#duffybackground", {
      duration: 1,
      ease: "power1.out",
      autoAlpha: 1,
      x: 0,
      y: 0
    })
    .from("#duffybackground", {
      duration: 1,
      ease: "power1.out",
      autoAlpha: 0,
      x: 0,
      y: 200
    })
    .set(targetPhoto, {
      duration: 3,
      ease: "power1.out",
      width: targetWidth,
      height: "100px",
      autoAlpha: 1,
      x: 0,
      y: 0
    })
    .from(targetPhoto, {
      duration: 3,
      ease: "power1.out",
      width: "700px",
      height: "910px",
      autoAlpha: 0,
      x: 300,
      y: 300
    })
    .set("#quotes",
    {
      duration: 1,
      ease: "power1.out",
      autoAlpha: 1,
      y: 0,
    })
    .from("#quotes",
    {
      duration: 1,
      ease: "power1.out",
      autoAlpha: 0,
      y: -100
    }, "-=1")
    .set("#citation",
    {
      duration: 1,
      ease: "power1.out",
      autoAlpha: 1,
      y: 0,
    })
    .from("#citation",
    {
      duration: 1,
      ease: "power1.out",
      autoAlpha: 0,
      y: 100
    }, "-=1")
    .set("#citationsignature1",
    {
      duration: 2,
      ease: "power1.out",
      autoAlpha: 1,
      x: 0,
    })
    .from("#citationsignature1",
    {
      duration: 2,
      ease: "power1.out",
      autoAlpha: 0,
      x: 100
    })
    .set("#citationsignature2",
    {
      duration: 2,
      ease: "power1.out",
      autoAlpha: 1,
      x: 0,
    })
    .from("#citationsignature2",
    {
      duration: 2,
      ease: "power1.out",
      autoAlpha: 0,
      x: 100
    }, "-=2");
}